import React, { useEffect } from 'react'
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  styled,
  SvgIcon,
  SxProps,
  Typography
} from '@mui/material'
import { Link } from 'react-router-dom'
import { CurrentTheme } from '../../../styles/themes'
import { ArrowLeftIcon } from '../../../icons'
import imgVNPLogo from 'media/images/VNpayIcon.png'
import __ from 'languages/index'
import TypedPlan from '../../../interfaces/plan.interface'
import RenderView from 'components/RenderView'

type Props = {
  onSubmit?: (plan: TypedPlan) => void
  onBack?: () => void
  plans?: TypedPlan[]
  fetchingPlans?: boolean
}

function getPlanFeature(desc: string) {
  return desc.split('-')
}

const PaymentStep = ({ onSubmit, onBack, plans, fetchingPlans }: Props) => {
  const [selectedPackage, setSelectedPackage] = React.useState<TypedPlan>(plans[0])

  const isFreemiumPackage = selectedPackage?.price === 0

  const handleSelectPackage = (plan: TypedPlan) => () => {
    setSelectedPackage(plan)
  }

  useEffect(() => {
    setSelectedPackage(plans[0])
  }, [plans])

  const renderPlans = () => {
    return (
      <Stack direction={'row'} gap={3}>
        {plans?.map(plan => (
          <PaymentOptionContainer
            active={plan?._id === selectedPackage?._id}
            className="basic-package"
            gap={2}
            onClick={handleSelectPackage(plan)}
          >
            <Stack className="package-header" direction="row">
              {/* <Box className="badge"> */}
              {/*   <Typography>{__('label_populate')}</Typography> */}
              {/* </Box> */}
              <Radio
                onClick={() => {
                  setSelectedPackage(plan)
                }}
                checked={plan?._id === selectedPackage?._id}
              />
            </Stack>
            <Stack gap={1}>
              <Typography variant="h5" fontWeight={700}>
                {plan?.name}
              </Typography>
              <Typography variant="h5" fontWeight={700}>
                {plan?.price} VND
              </Typography>
            </Stack>
            <Stack gap={2}>
              {getPlanFeature(plan?.description).map((feature, index) => (
                <Stack gap={1} direction="row">
                  <SvgIcon>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.0929 1.47897C11.1424 1.49251 11.1924 1.50617 11.2429 1.51987L12.2284 1.78737C12.5702 1.88016 12.6378 1.89552 12.6989 1.90201C12.7692 1.9095 12.8402 1.9095 12.9105 1.90201C12.9716 1.89552 13.0392 1.88016 13.381 1.78737L14.3665 1.51987C14.417 1.50617 14.4669 1.49251 14.5165 1.47897C15.2186 1.28722 15.834 1.11911 16.4348 1.1974C16.9596 1.26579 17.457 1.47182 17.8764 1.79457C18.3566 2.16398 18.6729 2.71806 19.0337 3.35007C19.0592 3.39469 19.0849 3.43971 19.1109 3.48507L19.6186 4.37105C19.7947 4.67836 19.8316 4.73704 19.8702 4.78482C19.9147 4.83986 19.9648 4.89003 20.0199 4.93448C20.0677 4.97306 20.1263 5.01002 20.4336 5.18611L21.3196 5.69379C21.365 5.71978 21.41 5.74548 21.4546 5.77095C22.0866 6.13178 22.6407 6.44811 23.0101 6.92825C23.3329 7.34772 23.5389 7.84512 23.6073 8.36994C23.6856 8.97066 23.5175 9.58612 23.3257 10.2882C23.3122 10.3377 23.2985 10.3877 23.2848 10.4382L23.0173 11.4237C22.9245 11.7655 22.9092 11.8331 22.9027 11.8942C22.8952 11.9645 22.8952 12.0355 22.9027 12.1058C22.9092 12.1669 22.9245 12.2345 23.0173 12.5763L23.2848 13.5618C23.2985 13.6123 23.3122 13.6623 23.3257 13.7118C23.5175 14.4139 23.6856 15.0293 23.6073 15.6301C23.5389 16.1549 23.3329 16.6523 23.0101 17.0718C22.6407 17.5519 22.0866 17.8682 21.4546 18.229C21.41 18.2545 21.365 18.2802 21.3196 18.3062L20.4336 18.8139C20.1263 18.99 20.0677 19.0269 20.0199 19.0655C19.9648 19.11 19.9147 19.1602 19.8702 19.2152C19.8316 19.263 19.7947 19.3216 19.6186 19.629L19.1109 20.5149C19.0849 20.5603 19.0592 20.6053 19.0337 20.6499C18.6729 21.2819 18.3566 21.836 17.8764 22.2054C17.457 22.5282 16.9596 22.7342 16.4348 22.8026C15.834 22.8809 15.2186 22.7128 14.5165 22.521C14.4669 22.5075 14.4169 22.4938 14.3665 22.4801L13.381 22.2126C13.0392 22.1199 12.9716 22.1045 12.9105 22.098C12.8402 22.0905 12.7692 22.0905 12.6989 22.098C12.6378 22.1045 12.5702 22.1199 12.2284 22.2126L11.2429 22.4801C11.1924 22.4938 11.1424 22.5075 11.0929 22.521C10.3908 22.7128 9.77536 22.8809 9.17463 22.8026C8.64981 22.7342 8.15241 22.5282 7.73294 22.2054C7.2528 21.836 6.93647 21.282 6.57565 20.6499C6.55017 20.6053 6.52447 20.5603 6.49848 20.5149L5.9908 19.629C5.81471 19.3216 5.77775 19.263 5.73917 19.2152C5.69471 19.1602 5.64454 19.11 5.5895 19.0655C5.54173 19.0269 5.48305 18.99 5.17574 18.8139L4.28975 18.3062C4.24439 18.2802 4.19938 18.2545 4.15476 18.2291C3.52275 17.8682 2.96867 17.5519 2.59925 17.0718C2.27651 16.6523 2.07048 16.1549 2.00208 15.6301C1.9238 15.0293 2.0919 14.4139 2.28366 13.7118C2.2972 13.6623 2.31086 13.6123 2.32455 13.5618L2.59206 12.5763L3.55714 12.8383L2.59206 12.5763C2.68485 12.2345 2.7002 12.1669 2.7067 12.1058C2.71419 12.0355 2.71419 11.9645 2.7067 11.8942C2.7002 11.8331 2.68485 11.7655 2.59206 11.4237L2.32455 10.4382C2.31086 10.3877 2.2972 10.3377 2.28366 10.2882C2.0919 9.58613 1.9238 8.97067 2.00208 8.36994C2.07048 7.84512 2.27651 7.34772 2.59925 6.92825C2.96867 6.44811 3.52274 6.13178 4.15476 5.77096C4.19938 5.74548 4.24439 5.71978 4.28976 5.69379L5.17574 5.18611C5.48305 5.01002 5.54173 4.97306 5.5895 4.93448C5.64455 4.89003 5.69471 4.83986 5.73917 4.78482C5.77775 4.73704 5.81471 4.67837 5.9908 4.37105L6.49848 3.48507C6.52447 3.43971 6.55017 3.3947 6.57564 3.35008C6.93647 2.71806 7.2528 2.16398 7.73294 1.79457C8.15241 1.47182 8.6498 1.26579 9.17463 1.1974C9.77536 1.11911 10.3908 1.28722 11.0929 1.47897ZM10.719 3.45002C9.77664 3.19423 9.58297 3.16109 9.43309 3.18063C9.25815 3.20342 9.09236 3.2721 8.95253 3.37968C8.83274 3.47185 8.71923 3.63222 8.23378 4.47941L7.72611 5.36539C7.71699 5.38131 7.70796 5.39709 7.69899 5.41276C7.56495 5.64703 7.44665 5.85378 7.2951 6.04143C7.16174 6.20655 7.01124 6.35706 6.84612 6.49041C6.65846 6.64197 6.45172 6.76026 6.21744 6.89431C6.20178 6.90327 6.18599 6.9123 6.17008 6.92142L5.2841 7.42909C4.43691 7.91454 4.27654 8.02805 4.18437 8.14784C4.07679 8.28767 4.00811 8.45346 3.98531 8.62841C3.96578 8.77828 3.99891 8.97195 4.25471 9.91426L4.52221 10.8997C4.52702 10.9174 4.53179 10.935 4.53653 10.9524C4.6074 11.2128 4.66995 11.4427 4.69547 11.6825C4.71793 11.8936 4.71793 12.1064 4.69547 12.3175C4.66995 12.5573 4.6074 12.7872 4.53653 13.0476C4.53179 13.065 4.52702 13.0826 4.52221 13.1003L4.25471 14.0857C3.99891 15.0281 3.96578 15.2217 3.98531 15.3716C4.00811 15.5465 4.07679 15.7123 4.18437 15.8522C4.27654 15.972 4.43691 16.0855 5.2841 16.5709L6.17008 17.0786C6.186 17.0877 6.20178 17.0967 6.21745 17.1057C6.45172 17.2397 6.65846 17.358 6.84612 17.5096C7.01124 17.643 7.16174 17.7935 7.2951 17.9586C7.44666 18.1462 7.56495 18.353 7.69901 18.5873C7.70796 18.6029 7.71699 18.6187 7.72611 18.6346L8.23378 19.5206C8.71923 20.3678 8.83274 20.5282 8.95253 20.6203C9.09235 20.7279 9.25815 20.7966 9.43309 20.8194C9.58297 20.8389 9.77664 20.8058 10.719 20.55L11.7044 20.2825C11.7221 20.2777 11.7397 20.2729 11.7571 20.2682C12.0175 20.1973 12.2474 20.1348 12.4872 20.1092C12.6983 20.0868 12.9111 20.0868 13.1222 20.1092C13.362 20.1348 13.5919 20.1973 13.8523 20.2682C13.8697 20.2729 13.8873 20.2777 13.905 20.2825L14.8904 20.55C15.8327 20.8058 16.0264 20.8389 16.1763 20.8194C16.3512 20.7966 16.517 20.7279 16.6569 20.6203C16.7766 20.5282 16.8902 20.3678 17.3756 19.5206L17.8833 18.6346C17.8924 18.6187 17.9014 18.6029 17.9104 18.5873C18.0444 18.353 18.1627 18.1462 18.3143 17.9586C18.4476 17.7935 18.5982 17.643 18.7633 17.5096C18.9509 17.358 19.1577 17.2398 19.3919 17.1057C19.4076 17.0967 19.4234 17.0877 19.4393 17.0786L20.3253 16.5709C21.1725 16.0855 21.3328 15.972 21.425 15.8522C21.5326 15.7123 21.6013 15.5465 21.6241 15.3716C21.6436 15.2217 21.6105 15.0281 21.3547 14.0857L21.0872 13.1003C21.0824 13.0826 21.0776 13.065 21.0729 13.0476C21.002 12.7872 20.9394 12.5573 20.9139 12.3175C20.8915 12.1064 20.8915 11.8936 20.9139 11.6825C20.9394 11.4427 21.002 11.2128 21.0729 10.9524C21.0776 10.935 21.0824 10.9174 21.0872 10.8997L21.3547 9.91426C21.6105 8.97195 21.6436 8.77828 21.6241 8.62841C21.6013 8.45346 21.5326 8.28767 21.425 8.14784C21.3328 8.02805 21.1725 7.91454 20.3253 7.42909L19.4393 6.92142C19.4234 6.9123 19.4076 6.90326 19.3919 6.8943C19.1577 6.76026 18.9509 6.64196 18.7633 6.49041C18.5981 6.35705 18.4476 6.20655 18.3143 6.04143C18.1627 5.85377 18.0444 5.64703 17.9104 5.41275C17.9014 5.39709 17.8924 5.38131 17.8833 5.36539L17.3756 4.47941C16.8902 3.63222 16.7766 3.47185 16.6569 3.37968C16.517 3.2721 16.3512 3.20342 16.1763 3.18063C16.0264 3.16109 15.8327 3.19423 14.8904 3.45002L13.905 3.71752C13.8873 3.72233 13.8697 3.7271 13.8523 3.73184C13.5919 3.80271 13.362 3.86526 13.1222 3.89078C12.9111 3.91325 12.6983 3.91325 12.4872 3.89078C12.2474 3.86526 12.0175 3.80271 11.7571 3.73184C11.7397 3.7271 11.7221 3.72233 11.7044 3.71752L10.719 3.45002ZM16.5118 9.2929C16.9023 9.68342 16.9023 10.3166 16.5118 10.7071L12.5776 14.6413C12.1696 15.0493 11.5156 15.0727 11.0795 14.6948L9.14988 13.023C8.73247 12.6613 8.68726 12.0298 9.04891 11.6124C9.41055 11.195 10.0421 11.1498 10.4595 11.5114L11.7559 12.6346L15.0976 9.2929C15.4881 8.90237 16.1213 8.90237 16.5118 9.2929Z"
                      />
                    </svg>
                  </SvgIcon>
                  <Typography>{feature}</Typography>
                </Stack>
              ))}
            </Stack>

            <Typography
              textAlign={'center'}
              sx={{
                ...detailPackageLinkStyled,
                borderTop: theme =>
                  `1px solid ${
                    isFreemiumPackage ? theme.palette.primary.contrastText : theme.palette.divider
                  }`,
                color: theme => isFreemiumPackage && theme.palette.primary.contrastText
              }}
            >
              <Link to="/">{__('txt_detail')}</Link>
            </Typography>
          </PaymentOptionContainer>
        ))}
      </Stack>
    )
  }

  return (
    <Stack gap={3}>
      <Typography variant="h4" component="h4" fontWeight={700}>
        Thanh toán
      </Typography>

      <RenderView view={renderPlans()} isLoading={fetchingPlans} />
      {!isFreemiumPackage && (
        <Stack gap={2}>
          <Typography variant="h6" fontWeight={700}>
            Phương thức thanh toán
          </Typography>
          <FormControl>
            <RadioGroup value="vnpay">
              <FormControlLabel
                value="vnpay"
                control={<Radio />}
                label={
                  <Stack direction={'row'} alignItems={'center'}>
                    <Box
                      component="img"
                      mr={1}
                      width={40}
                      height={40}
                      src={imgVNPLogo}
                      alt="momo"
                    />
                    <Typography fontWeight={600}>Thanh toán qua VNPay</Typography>
                  </Stack>
                }
              />
            </RadioGroup>
          </FormControl>
        </Stack>
      )}

      <Stack
        direction="row"
        justifyContent={'space-between'}
        alignItems={'center'}
        mt={2}
        width={'100%'}
      >
        <IconButton onClick={onBack}>
          <ArrowLeftIcon />
        </IconButton>
        <Button onClick={() => onSubmit(selectedPackage)}>Thanh toán</Button>
      </Stack>
    </Stack>
  )
}

export default PaymentStep

const detailPackageLinkStyled: SxProps<CurrentTheme> = {
  marginTop: 'auto',
  pt: theme => theme.spacing(2),
  '& a': {
    textDecoration: 'none',
    fontWeight: 600,
    color: 'inherit'
  }
}

const PaymentOptionContainer = styled(Stack, { shouldForwardProp: prop => prop !== 'active' })<{
  active: boolean
}>(({ theme, active }) => ({
  cursor: 'pointer',
  width: '100%',
  borderRadius: theme.spacing(1.5),
  padding: theme.spacing(3),
  backgroundColor: !active ? theme.palette.background.paper : theme.palette.primary.main,
  border: `1px solid ${!active ? theme.palette.divider : theme.palette.primary.main}`,
  '&  *:not(svg)': {
    color: active ? theme.palette.primary.contrastText : theme.palette.text.primary
  },

  '& .package-header': {
    justifyContent: 'flex-end'
  },
  '& .badge': {
    padding: theme.spacing(0, 1.5),
    marginRight: 'auto',
    backgroundColor: theme.palette.primary.contrastText,
    borderRadius: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.palette.primary.main}`,
    '& p': {
      color: theme.palette.primary.main,
      fontWeight: 600
    }
  },

  '&.basic-package': {}
}))
